import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as space from '../../../../space'
import * as capitalProject from '../capital-project'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: capitalProject.RESOURCE.payload.dimension.partialId,
      partialId: capitalProject.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Where does the project take place?',
    isOptional: true,
    name: 'Space',
    partialId: PartialId.Standard.create('space'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(space.RESOURCE.payload),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
